<template>
  <div class="base-phone-wrapper">
    <el-select v-model="countryCode" class="country-prepend" :placeholder="$lang('请输入')" :disabled="disabled">
      <el-option v-for="item in codeList" :key="item.code" :label="item.name" :value="item.code"></el-option>
    </el-select>
    <el-input :maxlength="maxlength" class="base-input-phone" @input="inputHandle" :placeholder="$lang('请输入电话')" v-model="phoneNumber" type="tel" :disabled="disabled" />
  </div>
</template>

<script>
export default {
  name: 'BasePhoneInput',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    // 禁止编辑
    disabled: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: [String, Number],
      default: 13
    }
  },
  computed: {
    countryCodeNew() {
      return this.$store.state.base.user.countryCode || ''
    },
    // 电话国家码
    countryCode: {
      get() {
        let countryCode = this.codeList[0].code
        if (this.value) {
          countryCode = this.value.substring(this.value.indexOf('+') + 1, this.value.indexOf('-'))
        }
        return countryCode
      },
      set(val) {
        this.$emit('input', `+${val}-${this.phoneNumber}`)
      },
    },
    // 电话
    phoneNumber: {
      get() {
        return this.value ? this.value.substring(this.value.indexOf('-') + 1, this.value.length) : ''
      },
      set(val) {
        console.log('phoneNumber', val, val.indexOf(0) === 0)
        // val = (val + '').replace(/0*(\d+)/, '$1')
        console.log('phoneNumber-----', val)
        this.$emit('input', this.countryCode && val ? `+${this.countryCode}-${val}` : val)
      },
    },
  },
  watch: {
    'countryCodeNew': {
      handler(val) {
        const that = this
        switch (val) {
          case 'UAE':
            that.codeList = [{ name: '+971', code: '971' }]
            break
          case 'KWT':
            that.codeList = [{ name: '+965', code: '965' }]
            break
          case 'QAT':
            that.codeList = [{ name: '+974', code: '974' }]
            break
          case 'BHR':
            that.codeList = [{ name: '+973', code: '973' }]
            break
          case 'OMN':
            that.codeList = [{ name: '+968', code: '968' }]
            break
          case 'JOR':
            that.codeList = [{ name: '+962', code: '962' }]
            break
          case 'KOA':
            that.codeList = [{ name: '+82', code: '82' }]
            break
          default:
            that.codeList = [{ name: '+966', code: '966' }]
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      codeList: [
        {
          name: '+966',
          code: '966',
        },
        // {
        //   name: '+86',
        //   code: '86',
        // },
      ],
    }
  },
  methods: {
    inputHandle (e) {
      console.log(e)
      if (e === 0 || e === '0') {
        this.$newMessage.warning(this.$lang('已自动过滤首位数0'))
      }
      this.phoneNumber = e.replace(/^0{1,}/g, '')
    },
  },
  mounted() {
    console.log(this.countryCodeNew, 12345)
  },
}
</script>

<style lang="scss" scoped>
.base-phone-wrapper {
  min-width: 198px;
  ::v-deep .el-input {
    .el-input__inner {
      border-radius: 0;
      &:hover:not([disabled]) {
        border-color: #c4c8cc;
      }
      &:focus:not([disabled]) {
        border-color: #c4c8cc;
      }
    }
  }
  .country-prepend {
    width: 80px !important;
    display: inline-block;
    border: none !important;
    ::v-deep .el-input {
      .el-input__inner {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }
    }
  }
  .country-prepend {
    ::v-deep .el-input {
      width: 80px !important;
    }
  }
  .base-input-phone {
    width: 115px !important;
    display: inline-block;
    ::v-deep .el-input__inner {
      border-left: 0;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }
}
</style>
